<template>
    <div>
        <h3 class="mb-3">{{ $t('profile') }}</h3>

        <TextInput v-model="user.first_name" :label="$t('first-name')" :error="!user.first_name && validate" />

        <TextInput v-model="user.last_name" :label="$t('last-name')" :error="!user.last_name && validate" />

        <TextInput v-model="user.display_name" :label="$t('display-name')" :error="!user.display_name && validate" @input="displayNameDirty = true" />

        <TextInput v-model="user.email" :label="$t('email')" :error="!user.email && validate" />

        <TextInput v-model="user.username" :label="$t('username')" :error="!user.username && validate" />
    </div>
</template>

<script>

export default {
    props: {
        user: Object,
        validate: Boolean,  // Set to true to trigger field validation
    },
    data() {
        return {
            displayNameDirty: this.user.display_name !== this.cleanDisplayName()
                && (this.user.display_name && this.user.first_name && this.user.last_name)
        }
    },
    methods: {
        cleanDisplayName() {
            return this.user.first_name && this.user.last_name
                ? `${this.user.first_name} ${this.user.last_name}`
                : this.user.first_name
                ? this.user.first_name
                : this.user.last_name
                ? this.user.last_name
                : ''
        }
    },
    watch: {
        user: {
            handler: function (newUser) {
                if (this.displayNameDirty) return

                newUser.display_name = this.cleanDisplayName()
            },
            deep: true,
        }
    },
}
</script>
